import Vue from "vue";

export const $socialPlan = {
    types: [
        {
            text: 'Reels',
            value: 'reels',
            icon: 'mdi-play-circle-outline'
        },
        {
            text: 'YouTube',
            value: 'youtube',
            icon: 'mdi-youtube'
        },
        {
            text: 'Posts Estáticos',
            value: 'static_post',
            icon: 'mdi-post'
        }
    ]
}

Vue.prototype.$socialPlan = $socialPlan;
